import { filterFinishedLoading, filterSubmitted } from '../../../Store/Filter/action';
import { FIXED_PERIOD_FILTERS } from '../../../Constants/Interest/Filter';
import { getInterestsByFixedPeriod } from '../../../Service/Interest/InterestService';
import { InterestTableState, INITIAL_TABLE_STATE } from '../../../Interface/Hook/Interest/InterestTableState';
import { InterestTableDTO } from '../../../Interface/Hook/Interest/InterestTableDTO';
import { Account, ClientType, ConstructionType, EnergyLabel, LoanForm, NHG } from '../../../Enum/Filters/';
import reduceTableByFixedPeriodData from '../../../Reducer/ReduceTableByFixedPeriodData';
import { tokenExpired } from '../../../Store/Auth/action';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import useFilterIsActual from '../UseFilterIsActual';
import { ErrorResponse } from '../../../Interface/ErrorResponse';
import { Period } from '../../../Interface/Interest/Period';

const useGetInterestByFixedPeriod = (
    constructionType: ConstructionType,
    energyLabel: EnergyLabel,
    loanForm: LoanForm,
    nhg: NHG,
    periodInMonths: Period[],
    riskCategory: string,
    clientType: ClientType,
    account: Account,
): InterestTableDTO => {
    const dispatch = useDispatch();
    const filterIsActual = useFilterIsActual(FIXED_PERIOD_FILTERS);

    const [{ error, data, headers, loading }, setState] = useState<InterestTableState>(INITIAL_TABLE_STATE);

    const fetchData = useCallback(() => {
        if (!filterIsActual) dispatch(filterSubmitted());
        if (filterIsActual && periodInMonths.length > 0)
            getInterestsByFixedPeriod(
                loanForm,
                periodInMonths,
                energyLabel,
                constructionType,
                nhg,
                riskCategory,
                clientType,
                account,
            ).then(
                result => {
                    setState({ error: false, ...reduceTableByFixedPeriodData(result), loading: false });
                    dispatch(filterFinishedLoading());
                },
                (errorResult: ErrorResponse) => {
                    errorResult.code === 403
                        ? dispatch(tokenExpired())
                        : setState({ error: true, data, headers, loading: false });
                    dispatch(filterFinishedLoading());
                },
            );
    }, [
        dispatch,
        constructionType,
        energyLabel,
        filterIsActual,
        loanForm,
        nhg,
        periodInMonths,
        riskCategory,
        data,
        headers,
        clientType,
        account,
    ]);

    useEffect(
        () => fetchData(),
        [loanForm, periodInMonths, energyLabel, constructionType, nhg, riskCategory, clientType, account]
    );

    return { data, error, headers, loading };
};

export default useGetInterestByFixedPeriod;
